import React, { SVGProps } from "react";

const SvgRoof3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 350 300"
    {...props}
  >
    <defs>
      <linearGradient
        id="roof3_svg__c"
        x1={244.346}
        y1={223.48}
        x2={211.425}
        y2={166.458}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.443} stopColor="#b8c9d5" stopOpacity={0} />
        <stop offset={1} stopColor="#b8c9d5" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof3_svg__a"
        x1={61.22}
        y1={246.436}
        x2={114.499}
        y2={154.154}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="roof3_svg__d"
        x1={288.956}
        y1={246.272}
        x2={234.806}
        y2={152.481}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.342} stopColor="#b8c9d5" stopOpacity={0} />
        <stop offset={1} stopColor="#b8c9d5" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof3_svg__e"
        x1={195.854}
        y1={287.857}
        x2={195.854}
        y2={199.256}
        xlinkHref="#roof3_svg__a"
      />
      <linearGradient
        id="roof3_svg__b"
        x1={328.731}
        y1={138.318}
        x2={328.731}
        y2={112.574}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof3_svg__f"
        x1={328.745}
        y1={175.498}
        x2={328.745}
        y2={149.753}
        xlinkHref="#roof3_svg__b"
      />
      <linearGradient
        id="roof3_svg__g"
        x1={216.752}
        y1={251.43}
        x2={216.752}
        y2={225.685}
        xlinkHref="#roof3_svg__b"
      />
      <linearGradient
        id="roof3_svg__h"
        x1={175.092}
        y1={227.116}
        x2={175.092}
        y2={201.371}
        xlinkHref="#roof3_svg__b"
      />
      <linearGradient
        id="roof3_svg__i"
        x1={21.399}
        y1={187.128}
        x2={21.399}
        y2={149.712}
        xlinkHref="#roof3_svg__b"
      />
      <linearGradient
        id="roof3_svg__j"
        x1={133.033}
        y1={251.43}
        x2={133.033}
        y2={225.685}
        xlinkHref="#roof3_svg__b"
      />
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="url(#roof3_svg__c)"
      d="M133.033 225.685v62.062l195.699-113.111v-62.062l-33.595 19.417-18.126-3.399-31.286 31.958-112.692 65.135z"
    />
    <path
      fill="url(#roof3_svg__a)"
      d="M133.033 225.685v62.062L21.399 223.445v-73.733l50.177-20.34 61.457 96.313z"
    />
    <path
      fill="url(#roof3_svg__d)"
      d="M216.752 220.849v67.008L328.745 223.3v-74.756l-51.233-20.719-60.76 93.024z"
    />
    <path
      fill="url(#roof3_svg__e)"
      d="M216.752 220.849v67.008l-41.796-24.341v-64.26l41.796 21.593z"
    />
    <g fill="#6d9faf">
      <path d="M75.875 153.952v11.261l-9.362-5.393v-11.261l9.362 5.393zM87.344 160.574v11.261l-9.363-5.393V155.18l9.363 5.394zM75.875 167.439V178.7l-9.362-5.393v-11.261l9.362 5.393zM87.344 174.061v11.261l-9.363-5.393v-11.261l9.363 5.393z" />
    </g>
    <path
      fill="#2277a9"
      d="m340 105.914-46.649 26.996-16.936-7.459-18.719 28.092-124.663 72.142-62.024-96.004L278.43 10 340 105.914z"
    />
    <path
      fill="#4ad9ff"
      d="M278.43 10 71.009 129.681 10 154.361l207.252-119.78L278.43 10z"
    />
    <path
      fill="#2682b7"
      d="m175.093 69.625 123.09 60.605 41.003 23.724-60.756-24.541-103.337-59.788z"
    />
    <path
      fill="#4befff"
      d="M175.093 69.625v131.746l41.672 23.858 61.665-95.816-103.337-59.788z"
    />
    <path fill="url(#roof3_svg__b)" d="M328.231 112.574h1v25.745h-1z" />
    <path fill="url(#roof3_svg__f)" d="M328.245 149.753h1v25.745h-1z" />
    <path fill="url(#roof3_svg__g)" d="M216.252 225.685h1v25.745h-1z" />
    <path fill="url(#roof3_svg__h)" d="M174.592 201.371h1v25.745h-1z" />
    <path fill="url(#roof3_svg__i)" d="M20.899 149.712h1v37.416h-1z" />
    <path fill="url(#roof3_svg__j)" d="M132.533 225.685h1v25.745h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeMiterlimit={10}
      d="M71.163 129.062 278.43 10M278.797 128.973 175.093 69.625"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m175.093 201.371-42.06 24.314-62.024-96.004L10 154.361l207.252-119.78L278.43 10 340 105.914l-41.817 24.316 41.003 23.724-60.756-24.541-61.665 95.816-41.672-23.858z"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      d="M297.799 130.704 175.093 69.625v131.746"
    />
  </svg>
);

export default SvgRoof3;
